export const getDuration = (expiry) => {
    let now = new Date().getTime();
    let duration = (expiry - now) / 1000;
    return duration;
}